<template>
  <div class="flex-0 mb-4 flex w-full justify-between py-2">
    <slot>
      <slot name="title">
        <PageTitle class="hidden lg:block">
          {{ pageTitle }}
        </PageTitle>
      </slot>
      <div class="ml-auto">
        <slot name="after" />
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
const { pageTitle } = usePageTitle()
</script>
